<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header" style="
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      background: transparent;
      border: 1px solid #a0a0a04d;
      color: #34393f;
      border-left: none;
    ">
    <mat-card-title class="mcd-card-title">Key Contacts</mat-card-title>
  </mat-card-header>

  <mat-card-content class="mcd-card-content">
    <div class="row filter-panel-row"
      style="align-items: center; margin-bottom: 20px; display: flex; justify-content: space-between;">
      <div class="col-auto d-flex align-items-center" style="display: flex; gap: 15px; flex-wrap: wrap;">
        <!-- Search Input matching Suppliers / Categories -->
        <div class="mcd-filter-dropdown-wrapper search-wrapper">
          <div class="mcd-search-header">
            <mat-icon class="search-icon">search</mat-icon>
            <input type="text" placeholder="Type to search.." class="search-input-field" [(ngModel)]="searchQuery" />
            <button type="button" class="clear-button" *ngIf="searchQuery" (click)="searchQuery = ''">
              <mat-icon class="clear-icon">close</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="col-auto text-right">
        <button *ngIf="canAddKeyContacts" class="btn-add-supplier-gold" (click)="openAddEditModal()">
          <span class="material-icons add-icon">add_circle_outline</span>
          Add New Contact
        </button>
      </div>
    </div>

    <!-- Table Wrapper -->
    <div class="table-wrapper" *ngIf="filteredKeyContacts.length > 0">
      <table class="table nrbes-grid">
        <thead class="thead-light">
          <tr>
            <th scope="col" width="30%">Name</th>
            <th scope="col" width="35%">Content Area</th>
            <th scope="col" width="25%">Email</th>
            <th scope="col" width="10%" style="text-align: center;">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredKeyContacts; let i = index">
            <!-- Name Column with Avatar Badge -->
            <td class="location-cell">
              <div style="display: flex; align-items: center; gap: 12px;">
                <span class="contact-avatar-circle" [style.background-color]="getAvatarColor(item.name, i)">
                  {{ getAvatarLetter(item.name) }}
                </span>
                <span class="contact-name-text" style="color: #4D5258;">{{ item.name }}</span>
              </div>
            </td>

            <!-- Content Area Column -->
            <td class="description">
              <span class="content-area-text">{{ item.contentArea || '--' }}</span>
            </td>

            <!-- Email Column -->
            <td>
              <a [href]="item.outlookEmailHyperLink" class="email-link">
                {{ item.email }}
              </a>
            </td>

            <!-- Action Column -->
            <td (click)="$event.stopPropagation()" style="text-align: center;">
              <a class="mcd-more-btn" [matMenuTriggerFor]="menu" *ngIf="canDeleteKeyContacts || canEditKeyContacts"
                href="javascript:void(0);" style="color: #c59b27; font-weight: bold;">
                <i class="material-icons">more_horiz</i>
              </a>
              <mat-menu #menu="matMenu" overlapTrigger="false">
                <button *ngIf="canEditKeyContacts" mat-menu-item (click)="openAddEditModal(item.id)">
                  <img src="/assets/images/d-edit 1.svg" style="margin-bottom: 3px; margin-right: 8px;" />
                  <span style="color: rgba(63, 81, 181, 1); font-weight: 500;">Edit</span>
                </button>
                <button *ngIf="canDeleteKeyContacts" mat-menu-item (click)="openDeletePopup(item)">
                  <img src="/assets/images/bin.svg" style="margin-bottom: 3px; margin-right: 8px;" />
                  <span style="color: rgba(222, 52, 40, 1); font-weight: 500;">Delete</span>
                </button>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="noResults" *ngIf="filteredKeyContacts.length == 0">
      No results found based on search terms.
    </div>
  </mat-card-content>
</mat-card>

<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>